/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveUsersAnalytics
 */
export interface ActiveUsersAnalytics {
    /**
     * 
     * @type {string}
     * @memberof ActiveUsersAnalytics
     */
    org_code: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    past_week: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    past_month: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    past_six_months: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    recent_week_percentage: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    recent_month_percentage: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveUsersAnalytics
     */
    recent_six_months_percentage: number;
}

/**
 * Check if a given object implements the ActiveUsersAnalytics interface.
 */
export function instanceOfActiveUsersAnalytics(value: object): value is ActiveUsersAnalytics {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('past_week' in value) || value['past_week'] === undefined) return false;
    if (!('past_month' in value) || value['past_month'] === undefined) return false;
    if (!('past_six_months' in value) || value['past_six_months'] === undefined) return false;
    if (!('recent_week_percentage' in value) || value['recent_week_percentage'] === undefined) return false;
    if (!('recent_month_percentage' in value) || value['recent_month_percentage'] === undefined) return false;
    if (!('recent_six_months_percentage' in value) || value['recent_six_months_percentage'] === undefined) return false;
    return true;
}

export function ActiveUsersAnalyticsFromJSON(json: any): ActiveUsersAnalytics {
    return ActiveUsersAnalyticsFromJSONTyped(json, false);
}

export function ActiveUsersAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveUsersAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['orgCode'],
        'past_week': json['pastWeek'],
        'past_month': json['pastMonth'],
        'past_six_months': json['pastSixMonths'],
        'recent_week_percentage': json['recentWeekPercentage'],
        'recent_month_percentage': json['recentMonthPercentage'],
        'recent_six_months_percentage': json['recentSixMonthsPercentage'],
    };
}

export function ActiveUsersAnalyticsToJSON(json: any): ActiveUsersAnalytics {
    return ActiveUsersAnalyticsToJSONTyped(json, false);
}

export function ActiveUsersAnalyticsToJSONTyped(value?: ActiveUsersAnalytics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgCode': value['org_code'],
        'pastWeek': value['past_week'],
        'pastMonth': value['past_month'],
        'pastSixMonths': value['past_six_months'],
        'recentWeekPercentage': value['recent_week_percentage'],
        'recentMonthPercentage': value['recent_month_percentage'],
        'recentSixMonthsPercentage': value['recent_six_months_percentage'],
    };
}

